var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"session-authorization pa-10"},[_c('title-page',{attrs:{"icon":"ico-carplug"}},[_vm._v(" "+_vm._s(_vm.$t('session-authorization.logs'))+" ")]),_c('session-authorization-list',{attrs:{"customer":_vm.customer}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }